"use strict";

const navBtns = document.querySelectorAll('button.hamburger');
const body = document.querySelector('body');
const withSub = document.querySelectorAll('nav .level-1 .with-subnav')
const box = document.querySelector('main .box:not(.header-image)');

if (box) {
    box.setAttribute('id', 'first-box');
}

navBtns.forEach((button) => {
    button.addEventListener('click', (event) => {
        if(!body.classList.contains('menu-open')) {
            addClass(navBtns, 'is-active', 'add', 0);
            addClass(body, ['header-fade-out', 'menu-open'], 'add', 400);
            addClass(navBtns, 'change-color', 'add', 700);
            addClass(body, 'fixed', 'add', 700);
        } else {
            addClass(navBtns, 'is-active', 'remove', 0);
            addClass(body, ['header-fade-out', 'menu-open'], 'remove', 400);
            addClass(navBtns, 'change-color', 'remove', 700);
            addClass(body, 'fixed', 'remove', 700);

            withSub.forEach((element) => {
                if(element.classList.contains('submenu-open')) {
                    element.classList.remove('submenu-open');
                }
            });
        }
    });
});

withSub.forEach((element) => {
    element.addEventListener('click', (event) => {
        const li = event.target.closest('li');

        if (!li.classList.contains('with-subnav')) {
            return true;
        }

        if (
            event.target.tagName === 'A'
            && li.classList.contains('submenu-open')
        ) {
            return true;
        }

        event.preventDefault();
        li.classList.toggle('submenu-open');
    });
});

function addClass(elements, classes, type, delay) {
    if (!isIterable(elements)) {
        elements = [elements];
    }

    if (typeof classes === 'string') {
        classes = [classes];
    }

    setTimeout(() => {
        for (let element of elements) {
            if (type === 'add') {
                for (let cls of classes) {
                    element.classList.add(cls);
                }
            } else {
                for (let cls of classes) {
                    element.classList.remove(cls);
                }
            }
        }
    }, delay);
}

function isIterable(obj) {
    if (obj == null) {
        return false;
    }
    return typeof obj[Symbol.iterator] === 'function';
}
